import { h, render } from "preact";
import register from "preact-custom-element";
import ProductOptions from "./product-options/product-options";
import { unavailableStockStatuses } from "./product-options/product-option-styles";

function ProductFormOptions({
  productId,
  idPrefix,
  initialVariantId,
  initialVariantHidden,
  initialFirstOptionValue,
  optionsRole,
  enableSwatchPreview,
  enableAccordions,
  quantityRequested,
  enableAvailabilityPreview,
}) {
  return (
    <ProductOptions
      productId={productId}
      idPrefix={idPrefix}
      initialVariantId={initialVariantId}
      initialVariantHidden={initialVariantHidden !== undefined}
      initialFirstOptionValue={initialFirstOptionValue}
      optionsRole={optionsRole}
      enableSwatchPreview={enableSwatchPreview !== undefined}
      enableAccordions={enableAccordions !== undefined}
      quantityRequested={quantityRequested}
      enableAvailabilityPreview={enableAvailabilityPreview !== undefined}
      unavailableStockStatuses={unavailableStockStatuses.waitlist}
      waitlistStockStatuses={unavailableStockStatuses.waitlist}
    />
  );
}

if (!customElements.get("product-form-options")) {
  register(
    ProductFormOptions,
    "product-form-options",
    [
      "product-id",
      "id-prefix",
      "initial-variant-id",
      "initial-variant-hidden",
      "initial-first-option-value",
      "options-role",
      "enable-swatch-preview",
      "enable-accordions",
      "quantity-requested",
      "enable-availability-preview",
    ],
    {
      shadow: false,
    },
  );
}
